export const CHURCH = {
  name: "Stafford Spiritualist Church",
  venue: "Northfield Centre",
  addressLines: ["Northfield Centre", "Co-operative Street", "Stafford", "ST16 3DA"],
  addressOneLine: "Northfield Centre, Co-operative Street, Stafford, ST16 3DA",
  phoneDisplay: "07516 997494",
  phoneHref: "tel:07516997494",
  serviceDay: "Every Sunday",
  serviceTime: "6:30pm",
  healingNote: "Healing is available before all Sunday services",
  website: "staffordspiritualistchurch.com",
  facebook: "https://www.facebook.com/staffordspiritualistchurch.co.uk/?locale=en_GB",
  instagram: "https://www.instagram.com/staffordspiritualchurch2021/",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Northfield+Centre+Co-operative+Street+Stafford+ST16+3DA",
};

export const IMAGES = {
  about: {
    url: "/posters/seven-principles.png",
    alt: "The Seven Principles of Spiritualism",
  },
};

export const POSTERS = [
  {
    id: "helen-metcalfe",
    medium: "Helen Metcalfe",
    date: "2026-08-23",
    dateLabel: "Sunday 23rd August 2026",
    timeLabel: "6:30pm",
    image: "/posters/helen-metcalfe.png",
  },
  {
    id: "darren-brittain",
    medium: "Darren Brittain",
    date: "2026-09-04",
    dateLabel: "Friday 4th September 2026",
    timeLabel: "7:00pm",
    image: "/posters/darren-brittain.png",
  },
  {
    id: "jarod-mason",
    medium: "Jarod Mason",
    date: "2026-09-06",
    dateLabel: "Sunday 6th September 2026",
    timeLabel: "6:30pm",
    image: "/posters/jarod-mason.png",
  },
  {
    id: "kyla-homer",
    medium: "Kyla Homer",
    date: "2026-09-13",
    dateLabel: "Sunday 13th September 2026",
    timeLabel: "6:30pm",
    image: "/posters/kyla-homer.png",
  },
  {
    id: "julie-ebrey",
    medium: "Julie Ebrey",
    date: "2026-09-20",
    dateLabel: "Sunday 20th September 2026",
    timeLabel: "6:30pm",
    image: "/posters/julie-ebrey.png",
  },
  {
    id: "linda-elstob",
    medium: "Linda Elstob",
    date: "2026-09-27",
    dateLabel: "Sunday 27th September 2026",
    timeLabel: "6:30pm",
    image: "/posters/linda-elstob.png",
  },
  {
    id: "ruth-jones",
    medium: "Ruth Jones",
    date: "2026-10-04",
    dateLabel: "Sunday 4th October 2026",
    timeLabel: "6:30pm",
    image: "/posters/ruth-jones.png",
  },
  {
    id: "mick-blacker",
    medium: "Mick Blacker",
    date: "2026-10-11",
    dateLabel: "Sunday 11th October 2026",
    timeLabel: "6:30pm",
    image: "/posters/mick-blacker.png",
  },
  {
    id: "lorine-mcdonald",
    medium: "Lorine McDonald",
    date: "2026-10-18",
    dateLabel: "Sunday 18th October 2026",
    timeLabel: "6:30pm",
    image: "/posters/lorine-mcdonald.png",
  },
  {
    id: "michelle-davies",
    medium: "Michelle Davies",
    date: "2026-10-25",
    dateLabel: "Sunday 25th October 2026",
    timeLabel: "6:30pm",
    image: "/posters/michelle-davies.png",
  },
  {
    id: "helen-metcalfe-nov",
    medium: "Helen Metcalfe",
    date: "2026-11-01",
    dateLabel: "Sunday 1st November 2026",
    timeLabel: "6:30pm",
    image: "/posters/helen-metcalfe-nov.png",
  },
  {
    id: "linda-wakefield",
    medium: "Linda Wakefield",
    date: "2026-11-08",
    dateLabel: "Sunday 8th November 2026",
    timeLabel: "6:30pm",
    image: "/posters/linda-wakefield.png",
  },
  {
    id: "gail-riding",
    medium: "Gail Riding",
    date: "2026-11-15",
    dateLabel: "Sunday 15th November 2026",
    timeLabel: "6:30pm",
    image: "/posters/gail-riding.png",
  },
  {
    id: "angie-mcghee",
    medium: "Angie McGhee",
    date: "2026-11-22",
    dateLabel: "Sunday 22nd November 2026",
    timeLabel: "6:30pm",
    image: "/posters/angie-mcghee.png",
  },
  {
    id: "carl-barlow",
    medium: "Carl Barlow",
    date: "2026-11-29",
    dateLabel: "Sunday 29th November 2026",
    timeLabel: "6:30pm",
    image: "/posters/carl-barlow.png",
  },
];

export const NEWS = [
  {
    id: "closed-30-august",
    tag: "Notices",
    date: "",
    title: "Church closed on 30th August",
    excerpt: "",
  },
  {
    id: "welcome-website",
    tag: "Notices",
    date: "5 July 2026",
    title: "A Warm Welcome to Our New Website",
    excerpt:
      "We are delighted to share our new online home. Here you will find service times, upcoming events and everything you need for your first visit. If anything is hard to find, just give us a ring — we are always happy to help.",
  },
];
